export default __webpack_public_path__ + "static/media/icon_javascript.38323140.png";